import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { billPaymentEndpoints } from '../data/apiData';

export const BillPayment: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-10 pb-8 border-b border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Bill Payment</h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-2xl mb-4">
          Pay utility bills, buy airtime and data, settle TV subscriptions, purchase insurance, and more —
          all from your agent account. Use the catalogue endpoints to discover available services and products,
          then follow the two-step initiate/authorize flow to complete a payment.
        </p>
        <div className="flex flex-wrap gap-2 mb-5">
          {['Airtime & Data', 'TV Subscriptions', 'Electricity', 'Insurance'].map(tag => (
            <span key={tag} className="inline-flex items-center gap-1.5 px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600">
              <span className="h-1.5 w-1.5 rounded-full bg-[#581689]" />
              {tag}
            </span>
          ))}
        </div>
        <div className="border-l-4 border-[#581689] pl-4 py-1">
          <p className="text-sm text-gray-600">
            <span className="font-semibold text-gray-800">Authentication:</span> Every request requires a Bearer token with the{' '}
            <code className="text-[#581689] bg-purple-50 px-1 py-0.5 rounded font-mono text-xs">BILL_PAYMENT_API</code> authority.
            The account debited is derived from the token — partners can only spend from their own agent account.
            The calling IP must appear in the token's{' '}
            <code className="text-[#581689] bg-purple-50 px-1 py-0.5 rounded font-mono text-xs">whitelisted_ips</code> claim.
          </p>
        </div>
      </div>

      <div className="space-y-6">
        {billPaymentEndpoints.map((endpoint) => (
          <ApiEndpoint key={endpoint.id} endpoint={endpoint} />
        ))}
      </div>
    </div>
  );
};
